/** Copy and icon for the profile line "Signed in using Google". */
export function signInCopy(method: string | null | undefined): {
  says: string;
  icon: string | null;
} {
  if (method === "google") {
    return { says: "Signed in using Google", icon: "/icons/sso-google.png" };
  }
  if (method === "microsoft") {
    return { says: "Signed in using Microsoft", icon: "/icons/sso-microsoft.png" };
  }
  return { says: "Signed in using email", icon: null };
}
